"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreenControl = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const hooks_1 = require("../hooks");
const FullScreenControl = () => {
    const sigma = hooks_1.useSigma();
    const [isFullScreen, setFullScreen] = react_1.useState(false);
    const containerRef = react_1.useRef(null);
    react_1.useEffect(() => {
        if (containerRef.current) {
            const sigmaRootElement = containerRef.current.closest("div.react-sigma-v2");
            if (sigmaRootElement) {
                if (isFullScreen && !sigmaRootElement.classList.contains("fullscreen"))
                    sigmaRootElement.classList.add("fullscreen");
                sigma.refresh();
                if (!isFullScreen && sigmaRootElement.classList.contains("fullscreen"))
                    sigmaRootElement.classList.remove("fullscreen");
                sigma.refresh();
            }
        }
    }, [isFullScreen, hooks_1.useSigma]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { ref: containerRef, className: `react-sigma-control-${isFullScreen ? "normalscreen" : "fullscreen"}` },
            react_1.default.createElement("button", { onClick: () => setFullScreen(!isFullScreen), title: "Toggle Fullscreen" }))));
};
exports.FullScreenControl = FullScreenControl;
//# sourceMappingURL=FullScreenControl.js.map